import { ACCOUNT_PAYMENT_OPTIONS_API } from 'constants/AppConstants';

export default async (paymentType, requestBody) => {
  try {
    const response = await fetch(`${ACCOUNT_PAYMENT_OPTIONS_API}?planLevelQualifierType=${paymentType}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    });
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
